import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1000.000000 981.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,981.000000) scale(0.100000,-0.100000)">
<path d="M6223 6883 c53 -2 97 -7 97 -11 0 -4 21 -5 48 -3 l47 5 -55 7 c-30 4
-95 7 -145 6 l-90 -1 98 -3z"/>
<path d="M6043 6873 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"/>
<path d="M5951 6866 c12 -10 59 -15 59 -6 0 5 -14 10 -32 10 -17 0 -29 -2 -27
-4z"/>
<path d="M6425 6860 c-13 -5 -14 -9 -5 -9 8 0 24 4 35 9 13 5 14 9 5 9 -8 0
-24 -4 -35 -9z"/>
<path d="M5835 6846 c-45 -11 -47 -12 -22 -18 15 -3 25 -3 22 1 -4 3 15 11 42
17 26 6 39 12 28 12 -11 0 -42 -5 -70 -12z"/>
<path d="M6510 6846 c19 -8 39 -11 45 -8 11 7 -29 20 -60 20 -12 0 -6 -5 15
-12z"/>
<path d="M6559 6823 c-13 -15 -12 -15 9 -4 23 12 28 21 13 21 -5 0 -15 -7 -22
-17z"/>
<path d="M5765 6819 c15 -7 10 -8 -20 -5 -31 4 -36 3 -22 -5 11 -6 35 -8 60
-3 38 7 40 8 17 15 -37 10 -59 10 -35 -2z"/>
<path d="M6600 6820 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"/>
<path d="M6640 6815 c0 -3 14 -11 30 -16 17 -6 30 -15 30 -21 0 -5 4 -7 9 -4
12 8 21 -18 16 -43 -3 -14 1 -18 12 -14 12 5 12 7 1 14 -8 6 -9 9 -1 9 6 0 18
2 25 5 9 4 14 -2 15 -15 1 -11 -1 -19 -5 -19 -4 1 -14 1 -22 0 -13 -1 -13 -3
-1 -10 9 -6 22 -4 36 5 19 13 23 13 28 1 3 -8 18 -14 33 -14 l27 0 -24 18
c-13 10 -31 18 -39 18 -27 -2 -35 1 -22 9 9 6 5 12 -13 20 -19 9 -24 9 -19 1
4 -7 2 -10 -5 -8 -7 3 -12 9 -12 14 0 11 -14 20 -64 41 -19 8 -35 12 -35 9z
m195 -105 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11
-10z"/>
<path d="M5635 6794 l-40 -14 40 5 c22 3 51 6 64 6 18 1 21 3 10 10 -17 11
-24 10 -74 -7z"/>
<path d="M5790 6790 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M5710 6780 c-34 -7 -34 -7 -5 -8 17 0 39 3 50 8 24 10 4 10 -45 0z"/>
<path d="M6650 6780 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M5773 6763 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5820 6761 c0 -5 13 -11 29 -14 16 -3 41 -9 56 -13 20 -5 26 -4 21 4
-5 8 3 10 26 5 18 -3 30 -3 26 1 -3 4 -30 9 -60 11 -29 1 -63 5 -75 8 -13 3
-23 2 -23 -2z"/>
<path d="M6010 6750 c34 -11 60 -11 35 0 -11 5 -29 8 -40 8 -16 0 -15 -2 5 -8z"/>
<path d="M5995 6730 c-3 -6 -18 -8 -33 -5 -26 5 -26 5 -4 -5 18 -7 29 -6 45 5
12 8 16 15 10 15 -7 0 -15 -5 -18 -10z"/>
<path d="M6006 6711 c-3 -5 3 -11 15 -14 16 -4 18 -3 8 9 -13 16 -16 17 -23 5z"/>
<path d="M6045 6710 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M6111 6655 c36 -17 80 -41 97 -54 18 -12 36 -19 42 -16 15 9 12 25
-5 25 -8 0 -15 6 -15 13 0 8 -3 7 -10 -3 -8 -12 -11 -12 -28 3 -10 9 -25 17
-33 18 -8 0 -6 4 6 9 18 8 18 9 -5 10 -14 2 -32 1 -39 0 -12 -1 -12 1 -4 12
10 11 4 14 -30 14 l-42 1 66 -32z m134 -63 c-3 -3 -11 0 -18 7 -9 10 -8 11 6
5 10 -3 15 -9 12 -12z"/>
<path d="M6885 6671 c-4 -8 -1 -19 9 -27 9 -8 11 -9 6 -2 -6 7 -10 16 -10 22
0 5 17 -8 37 -30 20 -21 36 -43 35 -47 -1 -5 2 -6 8 -2 9 6 12 -1 9 -22 -1 -5
-4 -7 -8 -6 -15 4 -7 -27 10 -43 16 -15 17 -14 12 4 -2 11 0 23 6 26 7 4 11
-1 11 -12 0 -11 7 -22 15 -26 24 -9 18 -28 -6 -21 -15 5 -19 4 -14 -5 4 -6 16
-9 26 -7 15 4 25 -5 44 -41 13 -26 24 -42 24 -37 1 6 -14 34 -32 64 -17 29
-38 64 -45 77 -7 13 -39 52 -71 85 -40 43 -60 58 -66 50z m115 -115 c0 -2 -8
-10 -17 -17 -16 -13 -17 -12 -4 4 13 16 21 21 21 13z"/>
<path d="M6290 6596 c7 -7 13 -7 20 0 6 6 3 10 -10 10 -13 0 -16 -4 -10 -10z"/>
<path d="M6264 6578 c-5 -7 -3 -8 5 -4 8 5 11 3 9 -6 -2 -7 0 -13 3 -13 4 0
15 -10 25 -22 15 -18 22 -20 34 -12 13 9 12 10 -2 5 -16 -5 -45 28 -40 46 3
12 -27 17 -34 6z"/>
<path d="M7411 6500 c215 -440 114 -960 -296 -1532 -232 -322 -641 -732 -1086
-1090 -403 -323 -919 -682 -1439 -1002 -113 -69 -212 -130 -220 -136 -37 -24
338 128 610 248 690 305 1280 653 1720 1015 120 99 423 404 513 517 120 151
223 313 303 475 133 273 177 449 178 710 1 183 -11 263 -60 412 -46 136 -149
325 -229 418 -25 29 -24 27 6 -35z"/>
<path d="M5370 6540 c-503 -62 -1141 -389 -1638 -839 -71 -65 -73 -66 -139
-71 l-66 -5 -614 -949 c-337 -521 -613 -950 -613 -952 0 -2 119 -4 263 -4
l264 0 105 168 105 167 342 3 c187 1 341 -1 341 -5 0 -5 7 -71 15 -148 8 -77
15 -150 15 -163 l0 -22 847 2 847 3 73 90 c146 180 301 410 407 607 40 74 46
92 46 145 0 133 -64 224 -187 264 -63 21 -92 23 -418 28 -390 7 -392 7 -414
74 -14 42 17 173 54 229 49 74 35 72 554 78 l464 5 48 180 c27 99 49 186 49
193 0 11 -96 13 -547 9 -608 -5 -619 -6 -758 -73 -176 -84 -276 -236 -354
-537 -86 -329 -26 -488 203 -543 57 -14 135 -18 405 -22 l334 -4 25 -25 c22
-22 24 -30 18 -76 -8 -74 -32 -150 -58 -182 -12 -15 -40 -36 -62 -46 -38 -17
-76 -19 -563 -19 -288 0 -523 3 -523 8 0 16 -160 1459 -165 1490 l-6 32 -191
0 -192 0 64 47 c325 237 760 407 1215 475 138 20 516 17 629 -5 320 -65 527
-196 626 -397 l42 -85 -6 116 c-10 209 -57 370 -146 496 -88 126 -202 202
-365 243 -93 24 -266 33 -375 20z m-1700 -1803 c11 -154 20 -290 20 -303 l0
-24 -215 0 c-118 0 -215 2 -215 4 0 4 311 516 359 591 15 25 26 34 28 25 2 -8
12 -140 23 -293z"/>
<path d="M6355 6500 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M6385 6480 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -9 11 -9 22 0 14
11 18 19 10 19 -3 0 -8 -5 -11 -10z"/>
<path d="M6970 6470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6418 6401 c19 -25 39 -56 45 -68 6 -13 14 -23 18 -23 4 0 10 -8 12
-17 4 -14 5 -13 6 4 0 12 -5 23 -11 25 -7 3 -13 13 -13 24 0 11 -6 18 -13 16
-8 -1 -12 3 -9 10 2 7 10 12 16 10 7 -1 10 2 6 8 -5 8 -11 8 -20 0 -11 -9 -14
-5 -12 22 2 31 0 33 -29 34 l-31 0 35 -45z m18 18 c0 -23 1 -23 -19 -1 -15 16
-15 18 1 19 11 1 18 -6 18 -18z"/>
<path d="M6466 6427 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M7052 6420 c7 -10 14 -18 15 -16 6 6 -9 36 -18 36 -5 0 -4 -9 3 -20z"/>
<path d="M7100 6350 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7123 6298 c1 -21 6 -38 11 -38 4 0 6 -13 4 -29 -3 -17 0 -27 5 -24
9 6 6 -37 -8 -87 -3 -15 0 -11 10 10 15 30 15 44 5 100 -16 85 -29 118 -27 68z"/>
<path d="M7085 6310 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M6506 6275 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M6533 6257 c-1 -30 -1 -31 8 -8 5 14 6 28 2 32 -4 4 -9 -6 -10 -24z"/>
<path d="M6515 6235 c4 -11 10 -28 12 -38 5 -15 8 -14 19 9 18 33 18 39 0 25
-11 -10 -17 -8 -26 6 -11 17 -11 16 -5 -2z"/>
<path d="M6541 6163 c0 -4 4 -17 9 -28 8 -19 9 -19 9 2 1 12 -3 25 -9 28 -5 3
-10 3 -9 -2z"/>
<path d="M7164 6025 c0 -66 1 -92 3 -57 2 34 2 88 0 120 -2 31 -3 3 -3 -63z"/>
<path d="M6562 6100 c0 -8 4 -26 8 -40 6 -20 8 -21 8 -5 0 11 -3 29 -8 40 -5
12 -8 14 -8 5z"/>
<path d="M6601 6094 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6585 6031 c-4 -23 -4 -45 -1 -48 3 -4 6 1 6 10 0 27 1 31 10 42 5 6
5 17 1 24 -6 9 -11 0 -16 -28z"/>
<path d="M7142 6035 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M6631 6024 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6592 5930 c0 -25 3 -36 5 -25 3 11 10 26 16 33 5 7 7 15 3 19 -3 3
-6 0 -7 -8 0 -8 -4 -6 -9 6 -6 15 -8 9 -8 -25z"/>
<path d="M6605 5856 c-4 -31 -5 -87 -3 -126 2 -38 0 -70 -4 -70 -4 0 -7 -21
-6 -47 l1 -48 4 45 c3 32 7 40 14 30 5 -10 8 23 5 90 -2 77 -1 90 4 50 7 -48
7 -44 6 33 -2 48 -5 90 -9 93 -3 3 -8 -19 -12 -50z"/>
<path d="M7144 5885 c6 -41 -4 -116 -15 -109 -11 6 -10 -4 0 -31 6 -15 11 -1
21 54 9 55 9 78 1 95 -10 19 -11 18 -7 -9z"/>
<path d="M7121 5704 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7107 5673 c-4 -3 -7 -20 -8 -37 0 -26 -2 -28 -8 -11 -7 17 -9 14
-13 -15 -3 -19 -1 -42 4 -50 6 -11 7 -8 2 9 -4 14 -2 21 4 17 5 -3 15 15 21
40 12 46 11 61 -2 47z"/>
<path d="M6610 5610 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6577 5508 c-9 -69 0 -75 9 -7 7 46 9 50 15 29 l8 -25 -2 24 c-4 47
-24 33 -30 -21z"/>
<path d="M7055 5550 c-3 -5 -2 -21 1 -37 7 -25 8 -25 15 -8 11 29 10 42 -2 25
-9 -12 -10 -11 -6 8 5 23 2 28 -8 12z"/>
<path d="M6592 5460 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M7050 5472 c0 -6 -7 -18 -16 -27 -9 -9 -14 -18 -11 -21 3 -3 13 6 23
20 9 15 14 29 10 33 -3 3 -6 1 -6 -5z"/>
<path d="M6561 5424 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6611 5424 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6999 5392 c-13 -15 -13 -20 -2 -30 13 -13 19 -4 14 22 -1 5 4 13 11
17 7 5 8 9 3 9 -6 0 -18 -8 -26 -18z"/>
<path d="M6551 5374 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6970 5351 c0 -10 19 -25 25 -20 1 2 -3 10 -11 17 -8 7 -14 8 -14 3z"/>
<path d="M6541 5334 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6963 5298 c0 -30 1 -30 10 -10 7 15 7 26 0 33 -6 6 -10 -1 -10 -23z"/>
<path d="M6530 5298 c0 -9 5 -20 10 -23 13 -8 13 5 0 25 -8 13 -10 13 -10 -2z"/>
<path d="M6942 5256 c1 -14 5 -23 9 -20 7 4 0 44 -7 44 -2 0 -3 -11 -2 -24z"/>
<path d="M6887 5233 c4 -11 8 -12 13 -3 6 9 9 9 13 1 4 -8 5 -8 3 0 -1 7 -9
13 -18 15 -11 1 -15 -3 -11 -13z"/>
<path d="M6515 5229 c-4 -6 -4 -13 -1 -16 3 -4 6 -1 6 6 0 7 5 9 12 5 7 -4 8
-3 4 4 -9 15 -13 15 -21 1z"/>
<path d="M6911 5199 c-11 -12 -17 -28 -14 -37 4 -9 2 -13 -4 -9 -6 4 -10 0 -9
-8 0 -9 -12 -23 -29 -33 -16 -9 -36 -23 -45 -31 -13 -13 -13 -14 3 -8 9 3 17
2 17 -4 0 -5 -7 -12 -15 -15 -12 -5 -13 -10 -4 -20 13 -16 31 -9 27 11 -2 8 6
21 17 30 20 16 19 16 -5 11 -24 -5 -24 -5 2 6 17 7 38 33 58 70 33 61 33 71 1
37z"/>
<path d="M6477 5118 c-19 -59 -23 -86 -16 -97 8 -12 8 -11 3 8 -4 17 -3 21 6
16 9 -5 11 -4 6 4 -4 6 2 41 14 77 12 36 20 67 18 69 -2 3 -16 -32 -31 -77z"/>
<path d="M6531 5154 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6500 5121 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M6436 5004 c-4 -9 -4 -19 -1 -22 3 -3 5 1 5 9 1 8 10 -2 21 -21 15
-26 18 -29 13 -10 -4 14 -12 33 -19 43 -12 17 -13 17 -19 1z"/>
<path d="M6795 5010 c-4 -6 -16 -8 -28 -5 -16 5 -18 4 -8 -3 12 -9 12 -13 -2
-27 -10 -9 -17 -21 -17 -26 0 -6 -4 -7 -10 -4 -6 4 -7 -1 -3 -11 6 -16 8 -15
16 5 6 12 16 20 23 17 7 -3 18 3 26 12 12 15 11 16 -4 3 -10 -7 -18 -9 -18 -3
0 10 20 30 33 31 8 1 11 11 4 17 -3 3 -8 0 -12 -6z"/>
<path d="M6428 4952 c3 -9 1 -13 -5 -9 -6 4 -13 -2 -16 -14 -5 -17 -3 -18 9
-8 24 20 35 46 19 46 -7 0 -11 -7 -7 -15z"/>
<path d="M6752 4919 c-7 -11 -17 -17 -22 -14 -6 3 -7 -1 -4 -9 4 -9 -1 -18
-10 -22 -9 -3 -16 -12 -16 -19 0 -9 -8 -12 -20 -10 -11 2 -18 0 -16 -4 8 -12
-30 -81 -39 -73 -5 4 -5 1 -1 -6 8 -14 26 -7 26 11 0 7 9 18 20 25 12 7 17 18
13 27 -3 9 -1 15 5 13 10 -3 87 90 80 97 -2 2 -9 -5 -16 -16z"/>
<path d="M6382 4874 c-9 -18 -9 -30 -1 -42 10 -16 10 -16 5 1 -7 21 3 49 15
41 5 -3 6 2 3 10 -8 21 -9 20 -22 -10z"/>
<path d="M6359 4820 c-1 -8 -1 -21 0 -29 2 -7 -2 -10 -7 -7 -5 3 -16 -11 -26
-30 -9 -20 -12 -33 -6 -29 5 3 10 0 10 -7 0 -7 9 -2 19 11 10 14 16 32 13 40
-5 14 -4 14 14 1 10 -8 16 -11 12 -6 -4 5 -3 18 3 29 7 13 8 17 1 13 -6 -4
-15 2 -21 11 -8 14 -11 15 -12 3z m19 -35 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6
7 -7 10 -15 7 -18z m-32 -41 c-4 -9 -9 -15 -11 -12 -3 3 -3 13 1 22 4 9 9 15
11 12 3 -3 3 -13 -1 -22z"/>
<path d="M6565 4751 c0 -9 4 -21 8 -27 4 -7 -5 -24 -18 -38 -26 -28 -33 -42
-15 -31 6 3 10 1 10 -4 0 -17 -18 -13 -30 7 -11 16 -11 16 -6 -1 3 -10 6 -21
6 -23 0 -16 30 2 55 34 16 20 21 31 12 23 -11 -9 -17 -10 -17 -2 0 6 11 16 24
21 33 12 39 25 20 41 -23 19 -51 18 -49 0z m49 -22 c-8 -14 -34 -11 -34 4 0 8
3 17 7 20 9 9 34 -13 27 -24z"/>
<path d="M6361 4714 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6297 4696 c-3 -8 1 -20 9 -26 10 -9 14 -9 14 -1 0 6 -4 11 -10 11
-5 0 -7 7 -4 15 4 8 4 15 1 15 -3 0 -7 -6 -10 -14z"/>
<path d="M6486 4678 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"/>
<path d="M6280 4666 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M6270 4640 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6245 4591 c-14 -20 -15 -23 -2 -12 9 7 23 11 31 8 8 -3 17 1 20 9 9
24 7 31 -4 14 -7 -11 -12 -12 -17 -4 -6 8 -14 3 -28 -15z"/>
<path d="M6470 4610 c-13 -8 -12 -10 3 -10 9 0 17 -4 17 -10 0 -5 -7 -7 -15
-4 -9 4 -22 -6 -35 -28 -17 -28 -20 -30 -20 -11 0 12 5 25 10 28 6 3 10 11 10
18 0 6 -7 2 -15 -10 -10 -14 -14 -35 -11 -57 3 -20 0 -36 -5 -36 -5 0 -9 -5
-9 -12 0 -6 8 -4 19 6 11 10 18 23 15 30 -2 6 3 20 12 31 16 20 16 20 9 0 -5
-16 0 -14 24 9 17 16 29 32 26 34 -3 3 3 11 13 19 15 13 15 13 -5 4 -13 -7
-23 -7 -25 -1 -2 6 -8 6 -18 0z m10 -40 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10
10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
<path d="M6405 4599 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M6305 4579 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M6245 4560 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -9 12 -9 24 1 10
7 19 14 21 15 2 2 -1 3 -7 3 -6 0 -14 -5 -17 -10z"/>
<path d="M6281 4544 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6206 4532 c-4 -7 -2 -12 4 -12 6 0 9 -4 6 -8 -2 -4 0 -14 6 -22 8
-13 9 -12 5 1 -3 9 0 22 6 29 9 10 9 11 0 6 -6 -3 -13 -1 -15 6 -3 9 -6 9 -12
0z"/>
<path d="M6186 4493 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M6335 4480 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M6371 4466 c-7 -8 -8 -17 -3 -20 6 -3 13 1 16 10 9 23 2 28 -13 10z"/>
<path d="M6165 4460 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M6345 4440 c6 -10 4 -12 -11 -6 -10 4 -15 4 -11 0 4 -4 0 -19 -9 -33
l-15 -26 19 22 c11 12 22 20 25 17 2 -3 7 2 10 10 4 9 1 18 -5 22 -7 5 -8 2
-3 -6z"/>
<path d="M6145 4430 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6135 4399 c3 -4 -2 -10 -11 -13 -18 -7 -9 -26 13 -26 9 0 13 6 10
14 -3 7 -1 18 4 23 6 6 4 10 -5 10 -8 0 -13 -4 -11 -8z"/>
<path d="M6279 4361 c8 -6 9 -11 3 -15 -6 -3 -13 -2 -17 4 -11 18 -24 10 -20
-13 4 -17 -2 -25 -26 -36 -21 -9 -29 -18 -25 -30 5 -13 3 -12 -8 2 -9 12 -16
14 -21 8 -3 -6 -1 -11 6 -11 8 0 8 -4 -1 -15 -7 -8 -9 -15 -4 -16 5 0 -1 -4
-14 -10 -14 -5 -20 -13 -16 -21 5 -8 2 -9 -10 -5 -10 4 -15 3 -11 -3 3 -6 1
-10 -4 -10 -6 0 -11 5 -11 11 0 5 -5 7 -11 4 -6 -5 -4 -12 8 -22 17 -14 17
-14 -2 -8 -16 5 -18 4 -7 -7 10 -10 32 7 118 93 88 88 101 105 82 106 -16 2
-19 0 -9 -6z"/>
<path d="M6087 4336 c-17 -26 -8 -29 26 -10 16 9 16 12 4 22 -12 10 -18 8 -30
-12z m14 -9 c-10 -9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z"/>
<path d="M6107 4303 c-3 -5 5 -8 18 -8 13 0 21 3 18 8 -2 4 -10 7 -18 7 -8 0
-16 -3 -18 -7z"/>
<path d="M6030 4255 c-20 -29 -26 -46 -19 -56 7 -11 9 -9 9 8 0 28 20 34 45
14 18 -14 18 -14 -1 9 -20 23 -23 57 -4 45 4 -3 13 1 19 8 8 10 7 14 -5 14 -8
0 -28 -19 -44 -42z"/>
<path d="M5968 4168 c-9 -13 -16 -27 -16 -31 -1 -5 -12 -17 -26 -28 -15 -11
-26 -24 -26 -29 0 -4 -20 -29 -45 -56 -42 -47 -57 -69 -69 -106 -3 -10 -11
-18 -17 -18 -8 0 -7 5 2 18 7 9 -3 2 -24 -17 -25 -24 -34 -38 -27 -46 5 -7 6
-16 2 -20 -4 -5 -1 -5 6 -1 7 4 10 12 7 17 -4 5 -1 9 5 9 7 0 10 7 6 15 -3 9
0 15 10 15 11 0 14 -5 10 -17 -5 -13 0 -11 18 6 14 13 23 28 20 33 -3 5 0 16
7 25 8 9 14 23 14 32 0 9 6 15 13 13 8 -1 11 2 7 8 -3 5 -2 10 4 10 5 0 12 -6
14 -12 4 -10 6 -10 6 0 1 6 6 12 12 12 5 0 8 -4 4 -9 -3 -5 -1 -12 4 -15 5 -3
27 14 49 38 22 24 42 42 45 40 2 -2 14 8 28 23 13 15 17 22 8 15 -20 -15 -59
-24 -59 -13 0 10 22 31 33 31 4 0 5 -6 1 -12 -4 -7 2 -4 14 6 27 24 27 26 0
21 -29 -6 -60 4 -53 16 4 5 15 9 27 9 18 0 19 2 7 17 -10 11 -10 14 -1 9 6 -4
12 -2 12 3 0 18 -17 12 -32 -11z m-5 -60 c-4 -7 -8 -24 -8 -38 -1 -14 -16 -40
-34 -59 -17 -19 -31 -28 -29 -20 2 8 -4 13 -14 13 -10 -1 -18 1 -18 5 1 12 25
37 43 44 10 4 15 12 12 17 -8 13 14 42 26 34 5 -3 9 0 9 5 0 6 5 11 11 11 6 0
7 -5 2 -12z"/>
<path d="M5925 4090 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M5900 4040 c-5 -3 -5 -11 0 -20 8 -13 10 -12 10 3 0 10 4 16 8 13 4
-2 14 -1 22 4 11 7 9 9 -8 7 -13 -1 -27 -4 -32 -7z"/>
<path d="M5840 3945 c-13 -14 -21 -27 -19 -30 3 -2 17 9 31 25 32 36 21 40
-12 5z"/>
<path d="M5662 3807 c-17 -18 -19 -24 -7 -24 8 0 25 11 37 24 16 17 18 23 6
23 -8 0 -24 -10 -36 -23z m28 9 c0 -2 -8 -10 -17 -17 -16 -13 -17 -12 -4 4 13
16 21 21 21 13z"/>
<path d="M5597 3738 c-31 -31 -31 -32 -2 -8 16 14 34 28 40 32 5 5 6 8 2 8 -4
0 -22 -15 -40 -32z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
